import React, { useMemo } from 'react';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import useAppColorMode from 'hooks/useAppColorMode';
import { createAppTheme } from 'theme/createAppTheme';

function AppThemeShell({ children }) {
  const { resolvedMode } = useAppColorMode();
  const theme = useMemo(() => createAppTheme(resolvedMode), [resolvedMode]);

  return (
    <MuiThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </MuiThemeProvider>
  );
}

export default AppThemeShell;
